import React, { useContext, useEffect } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import {
	IRestaurantsContext,
	RestaurantsContext,
} from '../../../../../../../Restaurants/restaurantsState/restaurantsContext';
import { useFetchData } from 'hooks/useFetchData';
import Text from 'components/Text/Text';
import BankSettingsBlock from './components/BankSettingsBlock';
import { getRestaurantBankSettings } from 'backend/restaurants';
import style from './BankSettingsTab.module.scss';

const BankSettingsTab: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { restaurantForFullInfo, restaurantFullInfoVisibleForm } =
		useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);
	const { fullInfoData } = useContext<IRestaurantsContext>(RestaurantsContext);
	const needRestaurantBankSettingsRequest =
		restaurantForFullInfo && restaurantFullInfoVisibleForm === 'bankSettingsForm';

	const { response, loading } = useFetchData(
		needRestaurantBankSettingsRequest ? getRestaurantBankSettings : null,
		fullInfoData.id || '',
	);

	useEffect(() => {
		loading ? showLoader() : hideLoader();
	}, [loading]);

	return (
		<div className={style.container} data-test="BankSettingsTab">
			<div className={style.bankSettingsWrapper}>
				<Text
					translationNameSpace="form"
					translationKey="bankSettingsHeading"
					theme="secondary"
					size="l"
					weight="bold"
				/>
				<BankSettingsBlock bankSettings={response?.data.restaurantBankSettings || []} />
			</div>
		</div>
	);
};

export default BankSettingsTab;
